<template>
  <div>
    <nav-bar></nav-bar>
    <section class="section container">
      <form id="submitItems" @submit.prevent="submit">
      <h1 class="title">Business Order Information</h1>
      <div class="field is-horizontal">
        <label class="label field-label">PO number / Sidemark</label>
        <div class="control field-body">
          <input class="input" type="text" v-model="po" placeholder="PO number or sidemark">
        </div>
      </div>
      <div class="field is-horizontal">
        <label class="label field-label">Quote number</label>
        <div class="control field-body">
          <input class="input" v-model="quoteNumber" type="text" placeholder="quote number">
        </div>
      </div>
      <div class="field is-horizontal">
        <label class="label field-label">Quote amount</label>
        <div class="control field-body">
          <input class="input" v-model="quoteAmount" type="number" min="0" placeholder="quote amount">
        </div>
      </div>
    </form>
    </section>
    <section class="section container">
      <p class="buttons has-text-centered">
        <button @click="back" class="button">back</button>
        <button @click="review" class="button">review</button>
        <!-- <button type="submit" form="submitItems" class="button is-primary">submit</button> -->
      </p>
    </section>
  </div>
</template>

<script>
import { submitOrder } from '@/utils/api';

export default {
  data() {
    return {
      po: JSON.parse(window.localStorage.getItem('ed-cart-po')),
      quoteNumber: JSON.parse(window.localStorage.getItem('ed-cart-quote-number')),
      quoteAmount: JSON.parse(window.localStorage.getItem('ed-cart-quote-amount')),
    };
  },
  methods: {
    back() {
      window.localStorage.setItem('ed-cart-po', JSON.stringify(this.po));
      window.localStorage.setItem('ed-cart-quote-amount', JSON.stringify(this.quoteAmount));
      window.localStorage.setItem('ed-cart-quote-number', JSON.stringify(this.quoteNumber));
      this.$router.push({ path: 'items' });
    },
    review() {
      window.localStorage.setItem('ed-cart-po', JSON.stringify(this.po));
      window.localStorage.setItem('ed-cart-quote-amount', JSON.stringify(this.quoteAmount));
      window.localStorage.setItem('ed-cart-quote-number', JSON.stringify(this.quoteNumber));
      this.$router.push({ name: 'buyReview' });
    },
    async submit() {
      const result = await submitOrder({
        quoteAmount: this.quoteAmount,
        quoteNumber: this.quoteNumber,
        po: this.po,
        notes: JSON.parse(window.localStorage.getItem('ed-cart-notes')),
        details: JSON.parse(window.localStorage.getItem('ed-cart-items')),
        operationSystem: JSON.parse(window.localStorage.getItem('ed-cart-operation-system')),
      });
      console.log(result);
      this.quote = null;
      this.po = null;
      window.localStorage.removeItem('ed-cart-operation-system');
      window.localStorage.removeItem('ed-cart-items');
      window.localStorage.removeItem('ed-cart-category');
      window.localStorage.removeItem('ed-cart-quote-number');
      window.localStorage.removeItem('ed-cart-quote-amount');
      window.localStorage.removeItem('ed-cart-po');
      window.localStorage.removeItem('ed-cart-last-id');
      window.localStorage.removeItem('ed-cart-notes');
      this.$router.push({ path: '/' });
    },
  },
};
</script>

<style scoped>
.buttons {
  justify-content: center;
}

input[type=number] {
    -moz-appearance:textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
